import { dcActionFlag } from '@nibras/core/common';
import { IElementTemplateHeader } from './common.interfaces';

export class ElementTemplateHeaderBase implements IElementTemplateHeader {
  ElementTemplateID: number;
  ElementTemplateName: string;
  ElementTemplateDescription: string;
  BaseElementTemplateID: number;
  ClassificationID: number;
  ElementTypeID: number;
  IsAbstract: boolean;
  IsSingleton: boolean;
  IsDeleted: boolean;
  CreatedBy: number;
  CreatedOn: Date;
  ActiveOn: Date;
  ActionFlag: number;

  constructor() {
    this.ActionFlag = dcActionFlag.Insert;
  }
}

export class dcElementTemplateHeader extends ElementTemplateHeaderBase {
  Level: number;
  BaseElementTemplateName: string;
  ElementTemplateVersionID: number; // only for client side
  isNewAttribute: boolean;
  constructor(id: number = null, name: string = '') {
    super();
    this.ElementTemplateID = id;
    this.ElementTemplateName = name;
  }
}
